/* eslint-disable no-shadow */
import eve from '@src/commonEvent';
import Utils from '@action/util';
import api from '@api/index';

const state = {
  userProfile: {},
  userSummary: {},
  deviceTotalCnt: {},
  fcNameResult: {},
  userProfileImage: '',
  franchiseProfileImage: '',
};

const getters = {
  fetchedUserProfile(state) {
    return state.userProfile;
  },
  fetchedUserSummary(state) {
    return state.userSummary;
  },
  fetchedUserProfileImage(state) {
    return state.userProfileImage;
  },
  fetchedFranchiseProfileImage(state) {
    return state.franchiseProfileImage;
  },
  fetchedDeviceTotalCnt(state) {
    return state.deviceTotalCnt;
  },
  fcNameResult(state) {
    return state.fcNameResult;
  },
};

const mutations = {
  SET_USER_PROFILE(state, payload) {
    state.userProfile = payload;
  },
  SET_USER_SUMMARY(state, payload) {
    state.userSummary = payload;
  },
  SET_USER_PROFILE_IMAGE(state, payload) {
    state.userProfileImage = payload;
  },
  SET_FRANCHISE_PROFILE_IMAGE(state, payload) {
    state.franchiseProfileImage = payload;
  },
  SET_DEVICE_CNT(state, payload) {
    state.deviceTotalCnt = payload;
  },
  SET_FC_NAME_RESULT(state, payload) {
    state.fcNameResult = payload;
  },
};

const actions = {
  async FETCH_USER_PROFILE({ commit }, userId) {
    const response = await api.myPage.fetchedUserProfile(userId);
    commit('SET_USER_PROFILE', response.data.items);
    return response;
  },

  async FETCH_USER_SUMMARY({ commit }) {
    const response = await api.myPage.fetchedUserSummary();
    commit('SET_USER_SUMMARY', response.data.items);
    commit('SET_DEVICE_CNT', response.data.items.device.total_count);
    return response;
  },

  async FETCH_USER_PROFILE_IMAGE({ commit }) {
    const response = await api.myPage.fetchedProfileImg();
    const arrayBuffer = response.data;

    if (arrayBuffer) {
      const image = `data:image/jpeg;base64,${Utils.convertArrayBufferToBase64(
        arrayBuffer,
      )}`;
      commit('SET_USER_PROFILE_IMAGE', image);
    }

    return response;
  },

  async FETCH_FRANCHISE_PROFILE_IMAGE({ commit }) {
    const response = await api.myPage.fetchedJoinedFCProfileImg();
    const arrayBuffer = response.data;

    if (arrayBuffer) {
      const image = `data:image/jpeg;base64,${Utils.convertArrayBufferToBase64(
        arrayBuffer,
      )}`;
      commit('SET_FRANCHISE_PROFILE_IMAGE', image);
    }

    return response;
  },

  EDIT_USER_PROFILE(_, profileInfo) {
    if (profileInfo.isChangeProfilePhoto === true) {
      api.myPage
        .editUserImage(profileInfo.selectedPhoto)
        .then(() => {
          window.location.href = `${window.location.origin}/mypage`;
        })
        .catch(() => {
          alert(eve.Lang.t('common.t_msg_insert_memberinfo'));
        });
    }
    if (profileInfo.isDisableChangePW === false) {
      api.myPage
        .editUserPassword(profileInfo.pw, profileInfo.pw_confirm)
        .then(() => {
          window.location.href = `${window.location.origin}/mypage`;
        })
        .catch(() => {
          alert(eve.Lang.t('common.t_msg_insert_memberinfo'));
        });
    }
    api.myPage
      .editUserProfile(profileInfo.telno)
      .then(() => {
        alert(eve.Lang.t('common.t_msg_complete'));
        window.location.href = `${window.location.origin}/mypage`;
      })
      .catch(() => {
        if (!profileInfo.telno) {
          alert(eve.Lang.t('common.d_confirm_phone'));
        } else {
          alert(eve.Lang.t('user.server_error'));
        }
      });
  },

  DELETE_PROFILE_PHOTO() {
    return api.myPage.deleteProfile();
  },

  REQUEST_JOIN_FC(_, franchiseCode) {
    return api.myPage.requestJoinFC(franchiseCode);
  },

  SEARCH_FC_NAME({ commit }, name) {
    return api.myPage.searchFranchise(name).then((response) => {
      commit('SET_FC_NAME_RESULT', response.data.items);
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
